document.addEventListener('shopify:section:load', function(event) {
  if (event.target.dataset.sectionType === 'slideshow') {
    var $slideshow = $(event.target).find('.slideshow');
    if ($slideshow.length && typeof $slideshow.slick === 'function') {
      $slideshow.slick({
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        speed: 600,
        fade: false,
        cssEase: 'linear'
      });
    }
  }
});
